<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end">
                    <ion-button @click="close()">
                        <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>{{ item.item_number }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <ion-slides v-if="images && images.length > 0">
                <ion-slide v-for="image in images" :key="image.unique_key">
                    <img :src="image.url"/>
                </ion-slide>
            </ion-slides>
            <img v-else :src="$assets.missingImageUrl"/>
            <ion-text color="primary">`
                <h3>{{ item.name }} <ion-badge v-if="item.note_summary" style="position: relative; top: 0.25em" color="danger">{{ item.note_summary }}</ion-badge></h3>
            </ion-text>
            <ion-text v-if="item.note_details" color="danger" style="white-space: pre-line">
                {{ item.note_details }}
            </ion-text>
            <ion-row v-if="hasShipmentInstructions && shipmentLine.picking_instructions">
                <ion-col size="4"><ion-label><strong>Picking</strong></ion-label></ion-col>
                <ion-col size="8"><ion-label>{{ shipmentLine.picking_instructions }}</ion-label></ion-col>
            </ion-row>
            <ion-row v-if="hasShipmentInstructions && shipmentLine.checking_instructions">
                <ion-col size="4"><ion-label><strong>Checking</strong></ion-label></ion-col>
                <ion-col size="8"><ion-label>{{ shipmentLine.checking_instructions }}</ion-label></ion-col>
            </ion-row>
            <ion-row v-if="hasShipmentInstructions && shipmentLine.packing_instructions">
                <ion-col size="4"><ion-label><strong>Packing</strong></ion-label></ion-col>
                <ion-col size="8"><ion-label>{{ shipmentLine.packing_instructions }}</ion-label></ion-col>
            </ion-row>
            <ion-text color="medium" class="ion-margin-top"><h4>Also Known As</h4></ion-text>
            <ion-row v-for="mpn in item.mpns" :key="mpn.id">
                <ion-col size="4">
                    <ion-label><strong>{{ mpnType(mpn.type) }}</strong></ion-label>
                </ion-col>
                <ion-col size="8">
                    <ion-label>{{ mpn.mpn }}</ion-label>
                </ion-col>
            </ion-row>
            <ion-row v-for="item_sku in item.skus" :key="item_sku.id">
                <ion-col size="4">
                    <ion-label><strong>SKU</strong></ion-label>
                </ion-col>
                <ion-col size="8">
                    <ion-label>
                        {{ item_sku.sku }}
                        <span v-if="sku && item_sku.id === sku.id">
                            (selected)
                        </span>
                    </ion-label>
                </ion-col>
            </ion-row>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonContent,
    IonButtons,
    IonButton,
    IonIcon
} from '@ionic/vue';
import {IonSlides, IonSlide, IonCol, IonRow, IonLabel, IonText} from '@ionic/vue';
import {modalController} from '@ionic/vue';
import {closeOutline} from 'ionicons/icons';

export default {
    props: ['item', 'sku', 'shipment-line'],
    name: 'ProductCard',
    components: {
        IonText,
        IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon,
        IonRow, IonCol, IonSlides, IonSlide, IonLabel
    },
    computed: {
        hasShipmentInstructions() {
            return this.shipmentLine && (
                this.shipmentLine.picking_instructions ||
                this.shipmentLine.packing_instructions ||
                this.shipmentLine.checking_instructions
            )
        },
        images() {
            if (this.sku && this.sku.image_urls && this.sku.image_urls.length > 0) {
                return this.sku.image_urls;
            }
            return this.item.image_urls;
        }
    },
    methods: {
        mpnType(type) {
            switch (type) {
                case 'supplier_bc':
                    return 'Item Barcode';
                case 'supplier_sku':
                    return 'Item SKU';
                default:
                    return type;
            }
        },
        close() {
            modalController.dismiss();
        }
    },
    setup() {
        return {
            closeOutline
        }
    }
}
</script>
